import useTranslation from 'next-translate/useTranslation';

import { PopUpBase } from '@/atoms';
import { BookingLavanda } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypePopUpBookingLavandaProps } from './types';

/**
 * PopUpBookingLavanda
 */
export const PopUpBookingLavanda: FunctionComponent<
  TypePopUpBookingLavandaProps
> = ({
  className = '',
  apartmentsByBuilding,
  buildings,
  onClose,
  show,
  province,
  defaultApartment,
  defaultBuilding,
}: TypePopUpBookingLavandaProps) => {
  const { t } = useTranslation('common');

  return (
    <PopUpBase
      state={show}
      funcionOnClose={onClose}
      className={`bg-surface-01 text-text-primary md:min-w-[500px] ${className}`}
      title={t('components.organisms.popUpBookingLavanda.title')}
    >
      <p className="text-body--primary mb-4 inline-block font-thin md:mb-6">
        {t('components.organisms.popUpBookingLavanda.description')}
      </p>

      <BookingLavanda
        buildings={buildings}
        apartmentsByBuilding={apartmentsByBuilding}
        defaultApartment={defaultApartment}
        defaultBuilding={defaultBuilding}
        province={province}
      />
    </PopUpBase>
  );
};

PopUpBookingLavanda.displayName = 'PopUpBookingLavanda';
